import { render, staticRenderFns } from "./roleUpdate.vue?vue&type=template&id=e47ab1a8&"
import script from "./roleUpdate.vue?vue&type=script&lang=js&"
export * from "./roleUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports